import CommChannelPanel from "./panels/CommChannelPanel";


const tabRoutes = [
  {
    name: "Communication Channels",
    path: "/communication-channels",
    component: <CommChannelPanel />
  }
  // {
  //   name: "Deals",
  //   path: "/deals",
  //   component: <DealsPanel />,
  // },
  // {
  //   name: "Offers",
  //   path: "/offers",
  //   component: <OffersPanel />,
  // },
];

export default tabRoutes;

